<template>
  <div>
    <div style="background-color:#1756A4">
      <div style="margin-bottom:30px">
        <pre></pre>
      </div>
        <marquee style="color:red;font-weight:bold;font-size:20px "  behavior="" direction="left"> {{ $t('sitetest') }}  </marquee>
      <div>
        <div>
          <b-row>
            <b-col>
              <b-row>
                <b-col>
                  <p style="margin-left:15%" class="MenuText">
                    {{ $t("uzb") }} <br />
                    {{ $t("uzb1") }}
                  </p>
                  <p class="text-right MenuTextPrezident">Ш.М.Мирзиёев</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col sm="12" lg="4">
                  <!-- <b-card class="bcard p-0">
                    <a
                      target="_blank"
                      href="https://xt.uzedu.uz/Vacancy/ListView"
                      style="text-decoration: none;"
                    >
                      <b-row>
                        <b-col class="p-0 m-0" style="display:contents;"
                          ><svg
                            class="ml-4 imageViewSearch"
                            xmlns="http://www.w3.org/2000/svg"
                            width="60"
                            height="55"
                            viewBox="0 0 32.001 32"
                          >
                            <path
                              id="Контур_519"
                              data-name="Контур 519"
                              d="M-1765.013,32a1.007,1.007,0,0,1-.716-.3l-7.114-7.113A14,14,0,0,1-1782,28a13.911,13.911,0,0,1-9.9-4.1A13.907,13.907,0,0,1-1796,14a13.908,13.908,0,0,1,4.1-9.9A13.91,13.91,0,0,1-1782,0a13.909,13.909,0,0,1,9.9,4.1A13.908,13.908,0,0,1-1768,14a13.994,13.994,0,0,1-3.41,9.157l7.113,7.114a1,1,0,0,1,.3.715,1.007,1.007,0,0,1-.3.717A1.007,1.007,0,0,1-1765.013,32ZM-1782,2a11.922,11.922,0,0,0-8.486,3.515A11.922,11.922,0,0,0-1794,14a11.92,11.92,0,0,0,3.515,8.485A11.922,11.922,0,0,0-1782,26a11.921,11.921,0,0,0,8.485-3.515A11.921,11.921,0,0,0-1770,14a11.922,11.922,0,0,0-3.515-8.486A11.92,11.92,0,0,0-1782,2Z"
                              transform="translate(1796)"
                              fill="#fff"
                            />
                          </svg>
                        </b-col>
                        <b-col
                          ><p
                            class="bcardText m-0 p-0"
                            style="display:contents;"
                          >
                            {{ $t("Bosh_ish_orinlari") }}
                            {{ $t("Bosh_ish_orinlari1") }}
                          </p></b-col
                        >
                      </b-row>
                    </a>
                  </b-card> -->
                </b-col>
                <b-col class="text-left pr-4 mr-4">
                  <b-input-group-append>
                    <b-form-input
                      style="min-height:30px"
                      @keyup="Search2"
                      size="lg"
                      class="searchinput "
                    >
                    </b-form-input>
                    <img
                      @keyup="Search2"
                      class="images"
                      width="25px"
                      src="@/assets/pictures/Сгруппировать 6960.png"
                    />
                    <div
                      class="dropdown-select-input"
                      v-if="searchshow"
                      v-click-outside="closeschoolinfo"
                    >
                      <ul>
                        <li
                          v-for="(item, index) in itemsSearch"
                          :key="index"
                          v-show="item.maintext == null || item.maintext == ''"
                        >
                          <!-- v-show="item.parentid == null" -->

                          <h6 class="mb-0">
                            <!-- {{ index + 1 }}. -->
                            <a
                              @click="RouterPush(item)"
                              class="my-text-success"
                            >
                              {{ item.headertext }}
                            </a>
                          </h6>
                          <!-- <p class="ml-2 pl-2">
                            {{ item.description }}
                          </p> -->
                        </li>
                        <li v-if="itemsSearch.length == 0">
                          <p class="text-center mb-0">
                            {{ $t("nothinghere") }}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </b-input-group-append>
                </b-col>
              </b-row>

              <!-- <b-row class="mb-5 pb-5">
                <b-col></b-col>
                <b-col>
                  <b-card class="bcard">
                    <a target="_blank" href="https://strategy.uz/">
                      <b-row>
                        <b-col style="display:contents;"
                          ><img
                            class="ml-4 imageView "
                            src="@/assets/pictures/Контур 518.png"
                        /></b-col>
                        <b-col
                          ><p
                            class="bcardText m-0 p-0"
                            style="display:contents;"
                          >
                            {{ $t("Taraqqiyot_strategiyasi_markazi") }}
                          </p></b-col
                        >
                      </b-row>
                    </a>
                  </b-card>
                </b-col>
                <b-col>
                  <b-card class="bcard">
                    <a
                      target="_blank"
                      href="https://xt.uzedu.uz/Vacancy/ListView"
                    >
                      <b-row>
                        <b-col style="display:contents;"
                          ><svg
                            class="ml-4 imageViewSearch"
                            xmlns="http://www.w3.org/2000/svg"
                            width="32.001"
                            height="32"
                            viewBox="0 0 32.001 32"
                          >
                            <path
                              id="Контур_519"
                              data-name="Контур 519"
                              d="M-1765.013,32a1.007,1.007,0,0,1-.716-.3l-7.114-7.113A14,14,0,0,1-1782,28a13.911,13.911,0,0,1-9.9-4.1A13.907,13.907,0,0,1-1796,14a13.908,13.908,0,0,1,4.1-9.9A13.91,13.91,0,0,1-1782,0a13.909,13.909,0,0,1,9.9,4.1A13.908,13.908,0,0,1-1768,14a13.994,13.994,0,0,1-3.41,9.157l7.113,7.114a1,1,0,0,1,.3.715,1.007,1.007,0,0,1-.3.717A1.007,1.007,0,0,1-1765.013,32ZM-1782,2a11.922,11.922,0,0,0-8.486,3.515A11.922,11.922,0,0,0-1794,14a11.92,11.92,0,0,0,3.515,8.485A11.922,11.922,0,0,0-1782,26a11.921,11.921,0,0,0,8.485-3.515A11.921,11.921,0,0,0-1770,14a11.922,11.922,0,0,0-3.515-8.486A11.92,11.92,0,0,0-1782,2Z"
                              transform="translate(1796)"
                              fill="#fff"
                            />
                          </svg>
                        </b-col>
                        <b-col
                          ><p
                            class="bcardText m-0 p-0"
                            style="display:contents;"
                          >
                            {{ $t("Bosh_ish_orinlari") }}
                            {{ $t("Bosh_ish_orinlari1") }}
                          </p></b-col
                        >
                      </b-row>
                    </a>
                  </b-card>
                </b-col>
                <b-col></b-col>
              </b-row> -->
            </b-col>
          </b-row>
        </div>
      </div>
      <div>
        <!-- <img width="100%" src="@/assets/pictures/Img.png" /> -->
        <div></div>
      </div>
    </div>

    <div style="margin-right:5%;margin-left:5%">
      <b-row>
        <b-col>
          <div class="container  ">
            <div class="row ">
              <div class="col text-center">
                <!-- <p class="infoTextB">
                  {{ $t("Regulations") }}
                </p> -->
              </div>
            </div>
          </div>
          <b-row>
            <b-col
              class="mt-4"
              sm="12"
              md="6"
              v-for="(item, index) in info"
              :key="index"
            >
              <b-card
                style="min-height: 140px; position:relative"
                class="menuCard p-2 hover1 "
                @click="
                  $router.push({ name: 'Regulations', params: { id: item.id } })
                "
              >
                <div>
                  <div class="redCard" style="background-color:#2386FF">
                    <svg
                      v-if="item.id == 519"
                      class="svgCard"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 128 98"
                    >
                      <g
                        id="school_icon"
                        data-name="school icon"
                        transform="translate(-960 -3358)"
                      >
                        <g
                          id="Контур_424"
                          data-name="Контур 424"
                          transform="translate(959.5 3357.5)"
                          fill="none"
                        >
                          <path
                            d="M16.122,98.5A15.64,15.64,0,0,1,.5,82.841V44.793h0q0-.171,0-.343c0-7.412,5.157-13.32,12.037-15.245L108.178,1.221a15.586,15.586,0,0,1,4.7-.721h.1a15.487,15.487,0,0,1,10.469,4.123q.529.487,1.012,1.021l.042.047.011.012A15.558,15.558,0,0,1,128.5,15.756h0c0,.031,0,.061,0,.091v.011c0,.029,0,.058,0,.087,0,0,0,.009,0,.014q0,.047,0,.095s0,0,0,.005q0,.05,0,.1V82.841A15.642,15.642,0,0,1,112.878,98.5Z"
                            stroke="none"
                          />
                          <path
                            d="M 112.8776397705078 94.50039672851562 C 115.9810333251953 94.50039672851562 118.8982391357422 93.28901672363281 121.0922775268555 91.08897399902344 C 123.2900390625 88.88589477539062 124.5003967285156 85.95659637451172 124.5003967285156 82.84069061279297 L 124.5003967285156 16.16011238098145 C 124.5003967285156 16.13780784606934 124.5003433227539 16.11553382873535 124.5001983642578 16.0932502746582 L 124.4965362548828 15.85599327087402 C 124.4259567260742 13.04627323150635 123.3999176025391 10.4589729309082 121.5265731811523 8.370733261108398 L 121.4877548217773 8.327652931213379 C 121.2485580444336 8.063272476196289 120.9945602416992 7.807053089141846 120.730339050293 7.563852787017822 C 118.6261520385742 5.623780727386475 115.894401550293 4.537909030914307 113.0301361083984 4.501094341278076 L 112.8776397705078 4.500412940979004 C 111.68359375 4.500412940979004 110.5076370239258 4.680552959442139 109.3824005126953 5.035852909088135 L 109.3012390136719 5.060533046722412 L 13.61499691009521 33.05591201782227 C 11.0029764175415 33.78657150268555 8.668916702270508 35.29075241088867 7.0427565574646 37.29135131835938 C 5.379536628723145 39.33759307861328 4.500396728515625 41.81261444091797 4.500396728515625 44.44887161254883 C 4.500396728515625 44.53407287597656 4.501336574554443 44.62051391601562 4.503176689147949 44.70585250854492 L 4.559476852416992 47.4919548034668 L 4.500396728515625 47.51526641845703 L 4.500396728515625 82.84069061279297 C 4.500396728515625 85.95717620849609 5.710436820983887 88.886474609375 7.907596588134766 91.08897399902344 C 10.10217666625977 93.28885650634766 13.0195369720459 94.50039672851562 16.12225723266602 94.50039672851562 L 112.8776397705078 94.50039672851562 M 112.8776397705078 98.50039672851562 L 16.12225723266602 98.50039672851562 C 11.94965648651123 98.50039672851562 8.026516914367676 96.87187194824219 5.075756549835205 93.91397094726562 C 2.124996662139893 90.9560546875 0.500396728515625 87.02339172363281 0.500396728515625 82.84069061279297 L 0.500396728515625 44.79349136352539 L 0.5040967464447021 44.79203414916992 C 0.5016367435455322 44.67789459228516 0.500396728515625 44.56359481811523 0.500396728515625 44.44887161254883 C 0.500396728515625 37.03637313842773 5.657116889953613 31.1284122467041 12.53745651245117 29.20379257202148 L 108.1780166625977 1.221472859382629 C 109.6610946655273 0.7531929016113281 111.2403335571289 0.5004129409790039 112.8776397705078 0.5004129409790039 C 112.9092330932617 0.5004129409790039 112.9405746459961 0.5005128979682922 112.9721145629883 0.5006929039955139 L 112.9728775024414 0.5004129409790039 C 116.8868789672852 0.5236328840255737 120.575813293457 1.980652928352356 123.4417572021484 4.623073101043701 C 123.7944564819336 4.947712898254395 124.1322555541992 5.288492679595947 124.4539566040039 5.644073009490967 C 124.4678955078125 5.65945291519165 124.4819946289062 5.675132751464844 124.4958801269531 5.690572738647461 C 124.4994735717773 5.694572925567627 124.5032348632812 5.698752880096436 124.5068130493164 5.702753067016602 C 126.9985961914062 8.480373382568359 128.401123046875 12.00721263885498 128.4952697753906 15.75553321838379 L 128.4953002929688 15.75597286224365 C 128.4960632324219 15.78647327423096 128.4967193603516 15.81691265106201 128.497314453125 15.84747314453125 C 128.4973907470703 15.85113334655762 128.4974822998047 15.85447311401367 128.4975433349609 15.85815334320068 C 128.4980773925781 15.88717269897461 128.49853515625 15.91599273681641 128.4989166259766 15.94503307342529 C 128.4989776611328 15.94977283477783 128.4990692138672 15.95421314239502 128.4991149902344 15.95895290374756 C 128.4995422363281 15.99055290222168 128.4998168945312 16.02221298217773 128.5000152587891 16.0538330078125 C 128.5000305175781 16.05541229248047 128.5000610351562 16.05753326416016 128.5000610351562 16.05911254882812 C 128.5002899169922 16.0927734375 128.5003967285156 16.12641334533691 128.5003967285156 16.16011238098145 L 128.5003967285156 82.84069061279297 C 128.5003967285156 87.02339172363281 126.8748931884766 90.9560546875 123.9241333007812 93.91397094726562 C 120.9742965698242 96.87187194824219 117.051139831543 98.50039672851562 112.8776397705078 98.50039672851562 Z"
                            stroke="none"
                            fill="#fff"
                          />
                        </g>
                        <path
                          id="Контур_425"
                          data-name="Контур 425"
                          d="M60,70h0V58a8.01,8.01,0,0,0-8-8H44a8.01,8.01,0,0,0-8,8V69.941c0,.02,0,.04,0,.059a2,2,0,0,1-4,0V58A12,12,0,0,1,44,46h8A12,12,0,0,1,64,58V70h0a2,2,0,1,1-4,0ZM74,60a2,2,0,0,1,0-4H94a2,2,0,1,1,0,4ZM2,60a2,2,0,0,1,0-4H22a2,2,0,1,1,0,4ZM2,36a2,2,0,1,1,0-4H94a2,2,0,1,1,0,4ZM26,20a2,2,0,0,1,0-4H94a2,2,0,1,1,0,4ZM78,4a2,2,0,1,1,0-4H94a2,2,0,1,1,0,4Z"
                          transform="translate(976 3376)"
                          fill="#fff"
                        />
                      </g>
                    </svg>

                    <svg
                      v-if="item.id == 520"
                      class="svgCard"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 16.866 20.199"
                    >
                      <path
                        id="Bag_Icon"
                        data-name="Bag Icon"
                        d="M16011.068,19392.1a3.239,3.239,0,0,1-1.25-.166,2.568,2.568,0,0,1-1.086-.5,4.2,4.2,0,0,1-1.831-3.432v-5.861a8.3,8.3,0,0,1,2.334-5.775v-2.93a1.332,1.332,0,1,1,2.664,0v1.084a8.238,8.238,0,0,1,6.5,0v-1.084a1.335,1.335,0,0,1,2.67,0v2.928a8.742,8.742,0,0,1,2.5,5.777V19388a4.075,4.075,0,0,1-2.918,3.936,6.66,6.66,0,0,1-1.249.166Zm-1.5-14.064a6.675,6.675,0,0,0-1.416,4.188v5.857a2.818,2.818,0,0,0,2.831,2.848h8.333a2.82,2.82,0,0,0,2.836-2.848v-5.857a7.14,7.14,0,0,0-1.334-4.187,7.91,7.91,0,0,0-2.419-2.006,6.232,6.232,0,0,0-3.249-.842,7.2,7.2,0,0,0-3.25.842c-.05.021-.1.045-.151.072a7.828,7.828,0,0,0-.972.654A8.92,8.92,0,0,0,16009.567,19378.037Zm3.084,9.877a.665.665,0,1,1,0-1.33h5a.717.717,0,0,1,.67.664.657.657,0,0,1-.67.666Z"
                        transform="translate(-16006.801 -19372.002)"
                        stroke="#fff"
                        stroke-width="0.2"
                      />
                    </svg>
                    <svg
                      v-if="item.id == 521"
                      class="svgCard"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 20.596 20.602"
                    >
                      <path
                        id="Контур_207"
                        data-name="Контур 207"
                        d="M11782.5,19720a2.5,2.5,0,0,1,0-5h15a2.5,2.5,0,1,1,0,5Zm-1.662-2.5a1.67,1.67,0,0,0,1.662,1.67h15a1.666,1.666,0,1,0,0-3.332h-15A1.666,1.666,0,0,0,11780.834,19717.5Zm2.5-10.832a6.665,6.665,0,1,1,6.666,6.67A6.672,6.672,0,0,1,11783.334,19706.666Zm.834,0a5.832,5.832,0,1,0,5.832-5.828A5.841,5.841,0,0,0,11784.168,19706.666Z"
                        transform="translate(-11779.702 -19699.701)"
                        stroke="#fff"
                        stroke-width="0.6"
                      />
                    </svg>
                    <svg
                      v-if="item.id == 522"
                      class="svgCard"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 24 25"
                    >
                      <g
                        id="Calendar_Icon"
                        data-name="Calendar Icon"
                        transform="translate(0 1)"
                      >
                        <g
                          id="Прямоугольник_117"
                          data-name="Прямоугольник 117"
                          transform="translate(0 4)"
                          fill="none"
                          stroke="#fff"
                          stroke-width="2"
                        >
                          <rect width="24" height="20" rx="6" stroke="none" />
                          <rect x="1" y="1" width="22" height="18" rx="5" />
                        </g>
                        <line
                          id="Линия_23"
                          data-name="Линия 23"
                          y2="8"
                          transform="translate(7)"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-width="2"
                        />
                        <line
                          id="Линия_24"
                          data-name="Линия 24"
                          y2="8"
                          transform="translate(17)"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-width="2"
                        />
                      </g>
                    </svg>
                    <svg
                      v-if="item.id == 523"
                      class="svgCard"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 16.327 19.602"
                    >
                      <path
                        id="Контур_432"
                        data-name="Контур 432"
                        d="M6457.771,21908.035l4.955,5.143s0,6.277,0,9.551a3.205,3.205,0,0,1-3.273,3.271h-8.182a3.205,3.205,0,0,1-3.273-3.271v-11.455a3.2,3.2,0,0,1,3.273-3.273Z"
                        transform="translate(-6447.2 -21907.199)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.6"
                      />
                    </svg>
                    <svg
                      v-if="item.id == 536"
                      class="svgCard"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 64 44"
                    >
                      <path
                        id="card_icon"
                        data-name="card icon"
                        d="M8,44a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0H56a8,8,0,0,1,8,8V36a8,8,0,0,1-8,8ZM4,8V36a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H8A4,4,0,0,0,4,8ZM44,28a4,4,0,0,1-4-4V20a4,4,0,0,1,4-4h8a4,4,0,0,1,4,4v4a4,4,0,0,1-4,4Zm0-7.5v3a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5h-7A.5.5,0,0,0,44,20.5Z"
                      />
                    </svg>
                  </div>
                  <div>
                    <p class="menuCardText17 mb-0 ml-3 mt-1 cardTopMargin">
                      {{ item.headertext }}
                    </p>
                    <p
                      style="maxLength: 15"
                      class="menuCardText14 mb-0 colorClass mt-1 ml-3 cardTopMargin"
                    >
                      {{ item.text }}
                    </p>
                  </div>
                </div>
                <!-- <b-row>
                  <b-col
                    sm="12"
                    lg="2"
                    class="redCard d-flex justify-content-center"
                    style="background-color:#2386FF"
                  >
                    <svg
                      v-if="item.id == 519"
                      class="svg p-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 128 98"
                    >
                      <g
                        id="school_icon"
                        data-name="school icon"
                        transform="translate(-960 -3358)"
                      >
                        <g
                          id="Контур_424"
                          data-name="Контур 424"
                          transform="translate(959.5 3357.5)"
                          fill="none"
                        >
                          <path
                            d="M16.122,98.5A15.64,15.64,0,0,1,.5,82.841V44.793h0q0-.171,0-.343c0-7.412,5.157-13.32,12.037-15.245L108.178,1.221a15.586,15.586,0,0,1,4.7-.721h.1a15.487,15.487,0,0,1,10.469,4.123q.529.487,1.012,1.021l.042.047.011.012A15.558,15.558,0,0,1,128.5,15.756h0c0,.031,0,.061,0,.091v.011c0,.029,0,.058,0,.087,0,0,0,.009,0,.014q0,.047,0,.095s0,0,0,.005q0,.05,0,.1V82.841A15.642,15.642,0,0,1,112.878,98.5Z"
                            stroke="none"
                          />
                          <path
                            d="M 112.8776397705078 94.50039672851562 C 115.9810333251953 94.50039672851562 118.8982391357422 93.28901672363281 121.0922775268555 91.08897399902344 C 123.2900390625 88.88589477539062 124.5003967285156 85.95659637451172 124.5003967285156 82.84069061279297 L 124.5003967285156 16.16011238098145 C 124.5003967285156 16.13780784606934 124.5003433227539 16.11553382873535 124.5001983642578 16.0932502746582 L 124.4965362548828 15.85599327087402 C 124.4259567260742 13.04627323150635 123.3999176025391 10.4589729309082 121.5265731811523 8.370733261108398 L 121.4877548217773 8.327652931213379 C 121.2485580444336 8.063272476196289 120.9945602416992 7.807053089141846 120.730339050293 7.563852787017822 C 118.6261520385742 5.623780727386475 115.894401550293 4.537909030914307 113.0301361083984 4.501094341278076 L 112.8776397705078 4.500412940979004 C 111.68359375 4.500412940979004 110.5076370239258 4.680552959442139 109.3824005126953 5.035852909088135 L 109.3012390136719 5.060533046722412 L 13.61499691009521 33.05591201782227 C 11.0029764175415 33.78657150268555 8.668916702270508 35.29075241088867 7.0427565574646 37.29135131835938 C 5.379536628723145 39.33759307861328 4.500396728515625 41.81261444091797 4.500396728515625 44.44887161254883 C 4.500396728515625 44.53407287597656 4.501336574554443 44.62051391601562 4.503176689147949 44.70585250854492 L 4.559476852416992 47.4919548034668 L 4.500396728515625 47.51526641845703 L 4.500396728515625 82.84069061279297 C 4.500396728515625 85.95717620849609 5.710436820983887 88.886474609375 7.907596588134766 91.08897399902344 C 10.10217666625977 93.28885650634766 13.0195369720459 94.50039672851562 16.12225723266602 94.50039672851562 L 112.8776397705078 94.50039672851562 M 112.8776397705078 98.50039672851562 L 16.12225723266602 98.50039672851562 C 11.94965648651123 98.50039672851562 8.026516914367676 96.87187194824219 5.075756549835205 93.91397094726562 C 2.124996662139893 90.9560546875 0.500396728515625 87.02339172363281 0.500396728515625 82.84069061279297 L 0.500396728515625 44.79349136352539 L 0.5040967464447021 44.79203414916992 C 0.5016367435455322 44.67789459228516 0.500396728515625 44.56359481811523 0.500396728515625 44.44887161254883 C 0.500396728515625 37.03637313842773 5.657116889953613 31.1284122467041 12.53745651245117 29.20379257202148 L 108.1780166625977 1.221472859382629 C 109.6610946655273 0.7531929016113281 111.2403335571289 0.5004129409790039 112.8776397705078 0.5004129409790039 C 112.9092330932617 0.5004129409790039 112.9405746459961 0.5005128979682922 112.9721145629883 0.5006929039955139 L 112.9728775024414 0.5004129409790039 C 116.8868789672852 0.5236328840255737 120.575813293457 1.980652928352356 123.4417572021484 4.623073101043701 C 123.7944564819336 4.947712898254395 124.1322555541992 5.288492679595947 124.4539566040039 5.644073009490967 C 124.4678955078125 5.65945291519165 124.4819946289062 5.675132751464844 124.4958801269531 5.690572738647461 C 124.4994735717773 5.694572925567627 124.5032348632812 5.698752880096436 124.5068130493164 5.702753067016602 C 126.9985961914062 8.480373382568359 128.401123046875 12.00721263885498 128.4952697753906 15.75553321838379 L 128.4953002929688 15.75597286224365 C 128.4960632324219 15.78647327423096 128.4967193603516 15.81691265106201 128.497314453125 15.84747314453125 C 128.4973907470703 15.85113334655762 128.4974822998047 15.85447311401367 128.4975433349609 15.85815334320068 C 128.4980773925781 15.88717269897461 128.49853515625 15.91599273681641 128.4989166259766 15.94503307342529 C 128.4989776611328 15.94977283477783 128.4990692138672 15.95421314239502 128.4991149902344 15.95895290374756 C 128.4995422363281 15.99055290222168 128.4998168945312 16.02221298217773 128.5000152587891 16.0538330078125 C 128.5000305175781 16.05541229248047 128.5000610351562 16.05753326416016 128.5000610351562 16.05911254882812 C 128.5002899169922 16.0927734375 128.5003967285156 16.12641334533691 128.5003967285156 16.16011238098145 L 128.5003967285156 82.84069061279297 C 128.5003967285156 87.02339172363281 126.8748931884766 90.9560546875 123.9241333007812 93.91397094726562 C 120.9742965698242 96.87187194824219 117.051139831543 98.50039672851562 112.8776397705078 98.50039672851562 Z"
                            stroke="none"
                            fill="#fff"
                          />
                        </g>
                        <path
                          id="Контур_425"
                          data-name="Контур 425"
                          d="M60,70h0V58a8.01,8.01,0,0,0-8-8H44a8.01,8.01,0,0,0-8,8V69.941c0,.02,0,.04,0,.059a2,2,0,0,1-4,0V58A12,12,0,0,1,44,46h8A12,12,0,0,1,64,58V70h0a2,2,0,1,1-4,0ZM74,60a2,2,0,0,1,0-4H94a2,2,0,1,1,0,4ZM2,60a2,2,0,0,1,0-4H22a2,2,0,1,1,0,4ZM2,36a2,2,0,1,1,0-4H94a2,2,0,1,1,0,4ZM26,20a2,2,0,0,1,0-4H94a2,2,0,1,1,0,4ZM78,4a2,2,0,1,1,0-4H94a2,2,0,1,1,0,4Z"
                          transform="translate(976 3376)"
                          fill="#fff"
                        />
                      </g>
                    </svg>

                    <svg
                      v-if="item.id == 520"
                      class="iconStyle p-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 16.866 20.199"
                    >
                      <path
                        id="Bag_Icon"
                        data-name="Bag Icon"
                        d="M16011.068,19392.1a3.239,3.239,0,0,1-1.25-.166,2.568,2.568,0,0,1-1.086-.5,4.2,4.2,0,0,1-1.831-3.432v-5.861a8.3,8.3,0,0,1,2.334-5.775v-2.93a1.332,1.332,0,1,1,2.664,0v1.084a8.238,8.238,0,0,1,6.5,0v-1.084a1.335,1.335,0,0,1,2.67,0v2.928a8.742,8.742,0,0,1,2.5,5.777V19388a4.075,4.075,0,0,1-2.918,3.936,6.66,6.66,0,0,1-1.249.166Zm-1.5-14.064a6.675,6.675,0,0,0-1.416,4.188v5.857a2.818,2.818,0,0,0,2.831,2.848h8.333a2.82,2.82,0,0,0,2.836-2.848v-5.857a7.14,7.14,0,0,0-1.334-4.187,7.91,7.91,0,0,0-2.419-2.006,6.232,6.232,0,0,0-3.249-.842,7.2,7.2,0,0,0-3.25.842c-.05.021-.1.045-.151.072a7.828,7.828,0,0,0-.972.654A8.92,8.92,0,0,0,16009.567,19378.037Zm3.084,9.877a.665.665,0,1,1,0-1.33h5a.717.717,0,0,1,.67.664.657.657,0,0,1-.67.666Z"
                        transform="translate(-16006.801 -19372.002)"
                        stroke="#fff"
                        stroke-width="0.2"
                      />
                    </svg>
                    <svg
                      v-if="item.id == 521"
                      class="svg p-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 20.596 20.602"
                    >
                      <path
                        id="Контур_207"
                        data-name="Контур 207"
                        d="M11782.5,19720a2.5,2.5,0,0,1,0-5h15a2.5,2.5,0,1,1,0,5Zm-1.662-2.5a1.67,1.67,0,0,0,1.662,1.67h15a1.666,1.666,0,1,0,0-3.332h-15A1.666,1.666,0,0,0,11780.834,19717.5Zm2.5-10.832a6.665,6.665,0,1,1,6.666,6.67A6.672,6.672,0,0,1,11783.334,19706.666Zm.834,0a5.832,5.832,0,1,0,5.832-5.828A5.841,5.841,0,0,0,11784.168,19706.666Z"
                        transform="translate(-11779.702 -19699.701)"
                        stroke="#fff"
                        stroke-width="0.6"
                      />
                    </svg>
                    <svg
                      v-if="item.id == 522"
                      class="svg p-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 24 25"
                    >
                      <g
                        id="Calendar_Icon"
                        data-name="Calendar Icon"
                        transform="translate(0 1)"
                      >
                        <g
                          id="Прямоугольник_117"
                          data-name="Прямоугольник 117"
                          transform="translate(0 4)"
                          fill="none"
                          stroke="#fff"
                          stroke-width="2"
                        >
                          <rect width="24" height="20" rx="6" stroke="none" />
                          <rect x="1" y="1" width="22" height="18" rx="5" />
                        </g>
                        <line
                          id="Линия_23"
                          data-name="Линия 23"
                          y2="8"
                          transform="translate(7)"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-width="2"
                        />
                        <line
                          id="Линия_24"
                          data-name="Линия 24"
                          y2="8"
                          transform="translate(17)"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-width="2"
                        />
                      </g>
                    </svg>
                    <svg
                      v-if="item.id == 523"
                      class="svg p-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 16.327 19.602"
                    >
                      <path
                        id="Контур_432"
                        data-name="Контур 432"
                        d="M6457.771,21908.035l4.955,5.143s0,6.277,0,9.551a3.205,3.205,0,0,1-3.273,3.271h-8.182a3.205,3.205,0,0,1-3.273-3.271v-11.455a3.2,3.2,0,0,1,3.273-3.273Z"
                        transform="translate(-6447.2 -21907.199)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.6"
                      />
                    </svg>
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="8">
                    <p class="menuCardText17 mb-0 ml-3 mt-1 cardTopMargin">
                      {{ item.headertext }}
                    </p>
                    <p
                      style="maxLength: 15"
                      class="menuCardText14 mb-0 colorClass mt-1 ml-3"
                    >
                      {{ item.text }}
                    </p>
                  </b-col>
                </b-row> -->
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <div
          :style="{
            borderLeft: '1px solid #000',
            minHeight: '600px',
          }"
        ></div>
        <b-col sm="12" lg="4">
          <!-- <div class="container ">
            <div class="row ">
              <div class="col text-center">
                <p class="infoTextB">
                  {{ $t("XALQ_TALIM_VAZIRLIGI_XIZMATLARI") }}
                </p>
              </div>
            </div>
          </div> -->
          <b-row>
            <b-col class="mt-4" sm="12" md="12">
              <b-card
                style="min-height: 140px"
                class="menuCard p-2 hover1 aboutButtons"
                @click="$router.push({ name: 'savol_javob' })"
              >
                <div>
                  <div class="redCard" style="background-color:#1756A4">
                    <svg
                      class="svgCard"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      id="Warstwa_3"
                      x="0px"
                      y="0px"
                      viewBox="0 0 430 430"
                      style="enable-background:new 0 0 430 430;"
                      xml:space="preserve"
                    >
                      <!-- <style type="text/css">
                        .st0{fill:#08A88A;}
                        .st1{fill:#121331;}
                        .st2{fill:#08A88A;fill-opacity:0;}
                        .st3{fill:none;}
                      </style> -->
                      <g>
                        <path
                          class="st1"
                          d="M380,386.3H215c-94.46,0-171.3-76.84-171.3-171.3S120.54,43.7,215,43.7S386.3,120.54,386.3,215v165   C386.3,383.48,383.48,386.3,380,386.3z M215,56.3c-87.51,0-158.7,71.19-158.7,158.7S127.49,373.7,215,373.7h158.7V215   C373.7,127.49,302.51,56.3,215,56.3z"
                        />
                        <path
                          class="st0"
                          d="M209.8,257.89c-3.13,0-5.84-2.32-6.24-5.51c-0.48-3.74-2.18-23.1,11.05-36.95c3.25-3.4,7.2-6.55,11.38-9.88   c11.54-9.19,23.46-18.7,23.46-35.09c0-18.85-15.66-31.52-30.29-31.52c-17.57,0-25.12,10.76-25.43,11.22   c-1.9,2.91-5.79,3.71-8.7,1.8c-2.91-1.9-3.71-5.83-1.81-8.75c0.45-0.69,11.32-16.87,35.94-16.87c20.63,0,42.89,16.87,42.89,44.12   c0,22.47-15.64,34.93-28.21,44.95c-3.84,3.06-7.46,5.94-10.12,8.73c-9.48,9.92-7.88,24.97-7.66,26.65c0.44,3.45-2,6.61-5.45,7.04   C210.33,257.87,210.07,257.89,209.8,257.89z"
                        />
                        <path
                          class="st0"
                          d="M222.13,294.03c0,6.33-5.13,11.47-11.47,11.47c-6.33,0-11.47-5.13-11.47-11.47c0-6.33,5.13-11.47,11.47-11.47   C217,282.57,222.13,287.7,222.13,294.03z"
                        />
                      </g>
                    </svg>
                  </div>
                  <div>
                    <p class="menuCardText17 mb-0 ml-3 mt-1 cardTopMargin">
                      {{ $t("answerandquestion") }}
                    </p>
                    <p
                      style="maxLength: 15"
                      class="menuCardText14 mb-0 colorClass mt-1 ml-3 cardTopMargin"
                    >
                      {{ $t("answerandquestion") }}
                    </p>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <!-- <b-col class="mt-4" sm="12" md="6">
              <b-card
                style="min-height: 120px"
                class="menuCard p-2 hover1 aboutButtons"
                @click="$router.push({ name: 'ota_onalar_tulovi' })"
              >
                <div>
                  <div class="redCard" style="background-color:#082852">
                    <svg
                      class="svgCard"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 64 44"
                    >
                      <path
                        id="card_icon"
                        data-name="card icon"
                        d="M8,44a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0H56a8,8,0,0,1,8,8V36a8,8,0,0,1-8,8ZM4,8V36a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H8A4,4,0,0,0,4,8ZM44,28a4,4,0,0,1-4-4V20a4,4,0,0,1,4-4h8a4,4,0,0,1,4,4v4a4,4,0,0,1-4,4Zm0-7.5v3a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5h-7A.5.5,0,0,0,44,20.5Z"
                      />
                    </svg>
                  </div>
                  <div>
                    <p class="menuCardText17 mb-0 ml-3 mt-1 cardTopMargin">
                      {{ $t("Ота_оналар_тўлови") }}
                    </p>
                    <p
                      style="maxLength: 15"
                      class="menuCardText14 mb-0 colorClass mt-1 ml-3 cardTopMargin"
                    >
                      {{ $t("ota_ona_tolov_info") }}
                    </p>
                  </div>
                </div>
              </b-card>
            </b-col> -->
          <!-- <b-col class="mt-4" sm="12" md="6">
              <b-card
                style="min-height: 120px"
                class="menuCard p-2 hover1 aboutButtons"
                @click="$router.push({ name: 'Oqishni-kochirish-va-tiklash' })"
              >
                <div>
                  <div class="redCard" style="background-color:#082852">
                    <svg
                      class="svgCard "
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 64 47.723"
                    >
                      <path
                        id="exchange_icon"
                        data-name="exchange icon"
                        d="M20.034,47.723h0A11.92,11.92,0,0,1,8.1,35.793l2.033-2.1,1.979,2.1a7.894,7.894,0,0,0,7.919,7.953H37.966a1.988,1.988,0,1,1,0,3.977ZM52.5,46.317l-8.139-8.139a1.988,1.988,0,1,1,2.812-2.812l4.715,4.715V11.931A8.015,8.015,0,0,0,43.9,3.977V0A11.945,11.945,0,0,1,54.888,7.287a11.885,11.885,0,0,1,.974,4.644V40.14l4.745-4.745a1.988,1.988,0,1,1,2.812,2.812l-8.11,8.11a1.988,1.988,0,0,1-2.812,0ZM12.115,35.792H8.1l.036-28.21L3.394,12.328a1.988,1.988,0,0,1-2.812,0,1.988,1.988,0,0,1,0-2.812l8.11-8.11a1.988,1.988,0,0,1,2.812,0l8.139,8.139a1.988,1.988,0,1,1-2.812,2.812L12.116,7.642v28.15ZM26.035,3.977a1.988,1.988,0,1,1,0-3.977H43.9L46,1.93,43.9,3.977H26.035Z"
                      />
                    </svg>
                  </div>
                  <div>
                    <p class="menuCardText17 mb-0 ml-3 mt-1 cardTopMargin">
                      {{ $t("O'qishni ko'chirish va tiklash") }}
                    </p>
                    <p
                      style="maxLength: 15"
                      class="menuCardText14 mb-0 colorClass mt-1 ml-3 cardTopMargin"
                    >
                      {{ $t("oqish_kochirish_va_tiklash_info") }}
                    </p>
                  </div>
                </div>
              </b-card>
            </b-col> -->
          <!-- <b-col class="mt-4" sm="12" md="6">
              <b-card
                style="min-height: 120px"
                class="menuCard p-2 hover1 aboutButtons"
                @click="$router.push({ name: 'Ijtimoiy-Soha' })"
              >
                <div>
                  <div class="redCard" style="background-color:#082852">
                    <svg
                      class="svgCard"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 64 59.151"
                    >
                      <path
                        id="social_icon"
                        data-name="social icon"
                        d="M47.14,58.084a13.5,13.5,0,0,1-3.369-2.047q-.353.163-.712.315a23.345,23.345,0,0,1-18.117,0q-.36-.152-.712-.315A13.577,13.577,0,1,1,10.291,33.067q.261-.11.524-.209a23.194,23.194,0,0,1,6.728-14.4,23.4,23.4,0,0,1,3.072-2.588,13.674,13.674,0,0,1-.192-2.29,13.576,13.576,0,1,1,27.151,0,13.686,13.686,0,0,1-.191,2.289,23.417,23.417,0,0,1,8.06,9.985,23.049,23.049,0,0,1,1.74,7.008q.264.1.524.209A13.579,13.579,0,0,1,47.14,58.084Zm1.51-3.574a9.7,9.7,0,0,0,8.52-17.394,23.2,23.2,0,0,1-6.714,14.249,23.393,23.393,0,0,1-3,2.539A9.7,9.7,0,0,0,48.65,54.51ZM8.719,38.719A9.7,9.7,0,0,0,20.546,53.9a23.413,23.413,0,0,1-7.991-9.936,23.045,23.045,0,0,1-1.726-6.851A9.682,9.682,0,0,0,8.719,38.719ZM34,54.3a19.277,19.277,0,0,0,7.045-1.319A13.572,13.572,0,0,1,52.424,32q.38,0,.757.021A19.342,19.342,0,0,0,47.713,21.2,19.6,19.6,0,0,0,46.1,19.747a13.585,13.585,0,0,1-24.192,0A19.61,19.61,0,0,0,20.286,21.2,19.344,19.344,0,0,0,14.818,32.02Q15.2,32,15.575,32A13.574,13.574,0,0,1,26.955,52.984,19.277,19.277,0,0,0,34,54.3ZM48.65,36.641A9.7,9.7,0,0,0,44.525,51.2a19.506,19.506,0,0,0,7.344-8.745,19.223,19.223,0,0,0,1.5-6.534q-.468-.045-.944-.045A9.634,9.634,0,0,0,48.65,36.641ZM16.13,42.458A19.5,19.5,0,0,0,23.474,51.2a9.695,9.695,0,0,0-7.9-15.325q-.476,0-.944.045A19.223,19.223,0,0,0,16.13,42.458ZM27.143,20.432a9.7,9.7,0,0,0,15.669-2.8q-.619-.316-1.264-.588a19.462,19.462,0,0,0-15.1,0q-.644.272-1.263.588A9.656,9.656,0,0,0,27.143,20.432ZM30.225,4.641A9.69,9.69,0,0,0,24.3,13.576q0,.085,0,.17.316-.145.637-.281a23.35,23.35,0,0,1,18.117,0q.321.136.636.28,0-.085,0-.17A9.7,9.7,0,0,0,30.225,4.641Z"
                        transform="translate(-2)"
                      />
                    </svg>
                  </div>
                  <div>
                    <p class="menuCardText17 mb-0 ml-3 mt-1 cardTopMargin">
                      {{ $t("Ijtimoiy_Soha") }}
                    </p>
                    <p
                      style="maxLength: 15"
                      class="menuCardText14 mb-0 colorClass mt-1 ml-3 cardTopMargin"
                    >
                      {{ $t("Ijtimoiy_soha_info") }}
                    </p>
                  </div>
                </div>
              </b-card>
            </b-col> -->
          <!-- <b-col class="mt-4" sm="12" md="6">
              <b-card
                style="min-height: 120px"
                class="menuCard p-2 hover1 aboutButtons"
                @click="$router.push({ name: 'Rasmiy-hujjatlar' })"
              >
                <div>
                  <div class="redCard" style="background-color:#082852">
                    <svg
                      class="svgCard"
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="55"
                      viewBox="0 0 48 64"
                    >
                      <path
                        id="document_icon"
                        data-name="document icon"
                        d="M8,64a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0H40a8,8,0,0,1,8,8V56a8,8,0,0,1-8,8ZM4,8V56a4,4,0,0,0,4,4H40a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H8A4,4,0,0,0,4,8Zm6,38a2,2,0,0,1,0-4H22a2,2,0,0,1,0,4Zm0-10a2,2,0,0,1,0-4H38a2,2,0,1,1,0,4Zm0-10a2,2,0,0,1,0-4H38a2,2,0,1,1,0,4Zm0-10a2,2,0,0,1,0-4H38a2,2,0,1,1,0,4Z"
                      />
                    </svg>
                  </div>
                  <div>
                    <p class="menuCardText17 mb-0 ml-3 mt-1 cardTopMargin">
                      {{ $t("Rasmiy_hujjatlar") }}
                    </p>
                    <p
                      style="maxLength: 15"
                      class="menuCardText14 mb-0 colorClass mt-1 ml-3 cardTopMargin"
                    >
                       {{ $t("Rasmiy_hujjat_info") }}
                    </p>
                  </div>
                </div>
              </b-card>
            </b-col> -->
          <b-row>
            <b-col class="mt-4" sm="12" md="12">
              <a
                href="https://oylik.uzedu.uz/#/"
                target="_blank"
                style="text-decoration: none;"
              >
                <b-card
                  style="min-height: 140px"
                  class="menuCard p-2 hover1 aboutButtons"
                >
                  <div>
                    <div class="redCard" style="background-color:#1756A4">
                      <svg
                        class="svgCard "
                        xmlns="http://www.w3.org/2000/svg"
                        width="60"
                        height="55"
                        viewBox="0 0 64 60.485"
                      >
                        <path
                          id="calculator_icon"
                          data-name="calculator icon"
                          d="M21.071,59.9,14,52.829,6.929,59.9A2,2,0,1,1,4.1,57.071L11.172,50,4.1,42.929A2,2,0,0,1,6.929,40.1L14,47.172,21.071,40.1A2,2,0,0,1,23.9,42.929L16.829,50,23.9,57.071A2,2,0,1,1,21.071,59.9ZM38,58a2,2,0,0,1,0-4H62a2,2,0,0,1,0,4Zm0-12a2,2,0,0,1,0-4H62a2,2,0,0,1,0,4ZM12,26V16H2a2,2,0,0,1,0-4H12V2a2,2,0,0,1,4,0V12H26a2,2,0,0,1,0,4H16V26a2,2,0,0,1-4,0ZM38,16a2,2,0,0,1,0-4H62a2,2,0,0,1,0,4Z"
                        />
                      </svg>
                    </div>
                    <div>
                      <p class="menuCardText17 mb-0 ml-3 mt-1 cardTopMargin">
                        {{ $t("Calculator") }}
                      </p>
                      <p
                        style="maxLength: 15"
                        class="menuCardText14 mb-0 colorClass mt-1 ml-3 cardTopMargin"
                      >
                        {{ $t("calculator_info") }}
                      </p>
                    </div>
                  </div>
                </b-card>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <!-- <div style="margin-right:5%;margin-left:5%">
      <b-row>
        <b-col sm="12" md="4" v-for="(item, index) in info" :key="index">
          <div class="col-sm-12 mt-3  col-md-6 col-lg-12 text-center">
            <div
              style="min-height:280px;"
              class="menuCard p-2 hover1 aboutButtons"
              @click="
                $router.push({ name: 'Regulations', params: { id: item.id } })
              "
            >
              <div class="text-left ml-3 mt-3 ">
                <svg
                  v-if="item.id == 519"
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="55"
                  viewBox="0 0 128 98"
                >
                  <g
                    id="school_icon"
                    data-name="school icon"
                    transform="translate(-960 -3358)"
                  >
                    <g
                      id="Контур_424"
                      data-name="Контур 424"
                      transform="translate(959.5 3357.5)"
                      fill="none"
                    >
                      <path
                        d="M16.122,98.5A15.64,15.64,0,0,1,.5,82.841V44.793h0q0-.171,0-.343c0-7.412,5.157-13.32,12.037-15.245L108.178,1.221a15.586,15.586,0,0,1,4.7-.721h.1a15.487,15.487,0,0,1,10.469,4.123q.529.487,1.012,1.021l.042.047.011.012A15.558,15.558,0,0,1,128.5,15.756h0c0,.031,0,.061,0,.091v.011c0,.029,0,.058,0,.087,0,0,0,.009,0,.014q0,.047,0,.095s0,0,0,.005q0,.05,0,.1V82.841A15.642,15.642,0,0,1,112.878,98.5Z"
                        stroke="none"
                      />
                      <path
                        d="M 112.8776397705078 94.50039672851562 C 115.9810333251953 94.50039672851562 118.8982391357422 93.28901672363281 121.0922775268555 91.08897399902344 C 123.2900390625 88.88589477539062 124.5003967285156 85.95659637451172 124.5003967285156 82.84069061279297 L 124.5003967285156 16.16011238098145 C 124.5003967285156 16.13780784606934 124.5003433227539 16.11553382873535 124.5001983642578 16.0932502746582 L 124.4965362548828 15.85599327087402 C 124.4259567260742 13.04627323150635 123.3999176025391 10.4589729309082 121.5265731811523 8.370733261108398 L 121.4877548217773 8.327652931213379 C 121.2485580444336 8.063272476196289 120.9945602416992 7.807053089141846 120.730339050293 7.563852787017822 C 118.6261520385742 5.623780727386475 115.894401550293 4.537909030914307 113.0301361083984 4.501094341278076 L 112.8776397705078 4.500412940979004 C 111.68359375 4.500412940979004 110.5076370239258 4.680552959442139 109.3824005126953 5.035852909088135 L 109.3012390136719 5.060533046722412 L 13.61499691009521 33.05591201782227 C 11.0029764175415 33.78657150268555 8.668916702270508 35.29075241088867 7.0427565574646 37.29135131835938 C 5.379536628723145 39.33759307861328 4.500396728515625 41.81261444091797 4.500396728515625 44.44887161254883 C 4.500396728515625 44.53407287597656 4.501336574554443 44.62051391601562 4.503176689147949 44.70585250854492 L 4.559476852416992 47.4919548034668 L 4.500396728515625 47.51526641845703 L 4.500396728515625 82.84069061279297 C 4.500396728515625 85.95717620849609 5.710436820983887 88.886474609375 7.907596588134766 91.08897399902344 C 10.10217666625977 93.28885650634766 13.0195369720459 94.50039672851562 16.12225723266602 94.50039672851562 L 112.8776397705078 94.50039672851562 M 112.8776397705078 98.50039672851562 L 16.12225723266602 98.50039672851562 C 11.94965648651123 98.50039672851562 8.026516914367676 96.87187194824219 5.075756549835205 93.91397094726562 C 2.124996662139893 90.9560546875 0.500396728515625 87.02339172363281 0.500396728515625 82.84069061279297 L 0.500396728515625 44.79349136352539 L 0.5040967464447021 44.79203414916992 C 0.5016367435455322 44.67789459228516 0.500396728515625 44.56359481811523 0.500396728515625 44.44887161254883 C 0.500396728515625 37.03637313842773 5.657116889953613 31.1284122467041 12.53745651245117 29.20379257202148 L 108.1780166625977 1.221472859382629 C 109.6610946655273 0.7531929016113281 111.2403335571289 0.5004129409790039 112.8776397705078 0.5004129409790039 C 112.9092330932617 0.5004129409790039 112.9405746459961 0.5005128979682922 112.9721145629883 0.5006929039955139 L 112.9728775024414 0.5004129409790039 C 116.8868789672852 0.5236328840255737 120.575813293457 1.980652928352356 123.4417572021484 4.623073101043701 C 123.7944564819336 4.947712898254395 124.1322555541992 5.288492679595947 124.4539566040039 5.644073009490967 C 124.4678955078125 5.65945291519165 124.4819946289062 5.675132751464844 124.4958801269531 5.690572738647461 C 124.4994735717773 5.694572925567627 124.5032348632812 5.698752880096436 124.5068130493164 5.702753067016602 C 126.9985961914062 8.480373382568359 128.401123046875 12.00721263885498 128.4952697753906 15.75553321838379 L 128.4953002929688 15.75597286224365 C 128.4960632324219 15.78647327423096 128.4967193603516 15.81691265106201 128.497314453125 15.84747314453125 C 128.4973907470703 15.85113334655762 128.4974822998047 15.85447311401367 128.4975433349609 15.85815334320068 C 128.4980773925781 15.88717269897461 128.49853515625 15.91599273681641 128.4989166259766 15.94503307342529 C 128.4989776611328 15.94977283477783 128.4990692138672 15.95421314239502 128.4991149902344 15.95895290374756 C 128.4995422363281 15.99055290222168 128.4998168945312 16.02221298217773 128.5000152587891 16.0538330078125 C 128.5000305175781 16.05541229248047 128.5000610351562 16.05753326416016 128.5000610351562 16.05911254882812 C 128.5002899169922 16.0927734375 128.5003967285156 16.12641334533691 128.5003967285156 16.16011238098145 L 128.5003967285156 82.84069061279297 C 128.5003967285156 87.02339172363281 126.8748931884766 90.9560546875 123.9241333007812 93.91397094726562 C 120.9742965698242 96.87187194824219 117.051139831543 98.50039672851562 112.8776397705078 98.50039672851562 Z"
                        stroke="none"
                        fill="#4871a3"
                      />
                    </g>
                    <path
                      id="Контур_425"
                      data-name="Контур 425"
                      d="M60,70h0V58a8.01,8.01,0,0,0-8-8H44a8.01,8.01,0,0,0-8,8V69.941c0,.02,0,.04,0,.059a2,2,0,0,1-4,0V58A12,12,0,0,1,44,46h8A12,12,0,0,1,64,58V70h0a2,2,0,1,1-4,0ZM74,60a2,2,0,0,1,0-4H94a2,2,0,1,1,0,4ZM2,60a2,2,0,0,1,0-4H22a2,2,0,1,1,0,4ZM2,36a2,2,0,1,1,0-4H94a2,2,0,1,1,0,4ZM26,20a2,2,0,0,1,0-4H94a2,2,0,1,1,0,4ZM78,4a2,2,0,1,1,0-4H94a2,2,0,1,1,0,4Z"
                      transform="translate(976 3376)"
                      fill="#4871a3"
                    />
                  </g>
                </svg>

                <svg
                  v-if="item.id == 520"
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="55"
                  viewBox="0 0 16.866 20.199"
                >
                  <path
                    id="Bag_Icon"
                    data-name="Bag Icon"
                    d="M16011.068,19392.1a3.239,3.239,0,0,1-1.25-.166,2.568,2.568,0,0,1-1.086-.5,4.2,4.2,0,0,1-1.831-3.432v-5.861a8.3,8.3,0,0,1,2.334-5.775v-2.93a1.332,1.332,0,1,1,2.664,0v1.084a8.238,8.238,0,0,1,6.5,0v-1.084a1.335,1.335,0,0,1,2.67,0v2.928a8.742,8.742,0,0,1,2.5,5.777V19388a4.075,4.075,0,0,1-2.918,3.936,6.66,6.66,0,0,1-1.249.166Zm-1.5-14.064a6.675,6.675,0,0,0-1.416,4.188v5.857a2.818,2.818,0,0,0,2.831,2.848h8.333a2.82,2.82,0,0,0,2.836-2.848v-5.857a7.14,7.14,0,0,0-1.334-4.187,7.91,7.91,0,0,0-2.419-2.006,6.232,6.232,0,0,0-3.249-.842,7.2,7.2,0,0,0-3.25.842c-.05.021-.1.045-.151.072a7.828,7.828,0,0,0-.972.654A8.92,8.92,0,0,0,16009.567,19378.037Zm3.084,9.877a.665.665,0,1,1,0-1.33h5a.717.717,0,0,1,.67.664.657.657,0,0,1-.67.666Z"
                    transform="translate(-16006.801 -19372.002)"
                    stroke="#011422"
                    stroke-width="0.2"
                  />
                </svg>
                <svg
                  v-if="item.id == 521"
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="55"
                  viewBox="0 0 20.596 20.602"
                >
                  <path
                    id="Контур_207"
                    data-name="Контур 207"
                    d="M11782.5,19720a2.5,2.5,0,0,1,0-5h15a2.5,2.5,0,1,1,0,5Zm-1.662-2.5a1.67,1.67,0,0,0,1.662,1.67h15a1.666,1.666,0,1,0,0-3.332h-15A1.666,1.666,0,0,0,11780.834,19717.5Zm2.5-10.832a6.665,6.665,0,1,1,6.666,6.67A6.672,6.672,0,0,1,11783.334,19706.666Zm.834,0a5.832,5.832,0,1,0,5.832-5.828A5.841,5.841,0,0,0,11784.168,19706.666Z"
                    transform="translate(-11779.702 -19699.701)"
                    stroke="#4871a3"
                    stroke-width="0.6"
                  />
                </svg>
                <svg
                  v-if="item.id == 522"
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="55"
                  viewBox="0 0 24 25"
                >
                  <g
                    id="Calendar_Icon"
                    data-name="Calendar Icon"
                    transform="translate(0 1)"
                  >
                    <g
                      id="Прямоугольник_117"
                      data-name="Прямоугольник 117"
                      transform="translate(0 4)"
                      fill="none"
                      stroke="#4871a3"
                      stroke-width="2"
                    >
                      <rect width="24" height="20" rx="6" stroke="none" />
                      <rect x="1" y="1" width="22" height="18" rx="5" />
                    </g>
                    <line
                      id="Линия_23"
                      data-name="Линия 23"
                      y2="8"
                      transform="translate(7)"
                      stroke="#4871a3"
                      stroke-linecap="round"
                      stroke-width="2"
                    />
                    <line
                      id="Линия_24"
                      data-name="Линия 24"
                      y2="8"
                      transform="translate(17)"
                      stroke="#4871a3"
                      stroke-linecap="round"
                      stroke-width="2"
                    />
                  </g>
                </svg>
                <svg
                  v-if="item.id == 523"
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="55"
                  viewBox="0 0 16.327 19.602"
                >
                  <path
                    id="Контур_432"
                    data-name="Контур 432"
                    d="M6457.771,21908.035l4.955,5.143s0,6.277,0,9.551a3.205,3.205,0,0,1-3.273,3.271h-8.182a3.205,3.205,0,0,1-3.273-3.271v-11.455a3.2,3.2,0,0,1,3.273-3.273Z"
                    transform="translate(-6447.2 -21907.199)"
                    fill="none"
                    stroke="#4871a3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.6"
                  />
                </svg>

             
              </div>
              <p class="menuCardText24 text-left ml-3 mt-3 marginCard">
                {{ item.headertext }}
              </p>
              <p
                style="maxLength: 25"
                class="menuCardText17 colorClass text-left ml-3 mt-4"
              >
                {{ item.text }}
              </p>
              
            </div>
          </div>
        </b-col>
      </b-row>
    </div> -->

    <div style="margin-right:5%;margin-left:5%"></div>
    <div style="margin-right:5%;margin-left:5%">
      <div class="row mt-3 d-flex justify-content-around">
        <div class="col-sm-12 mt-3  col-md-6 col-lg-4 text-center">
          <div
            style="min-height:280px;"
            class="menuCard p-2 hover1 aboutButtons"
            @click="$router.push({ name: 'Qabul' })"
          >
            <div class="text-left ml-3 mt-3 ">
              <svg
                class="svg"
                xmlns="http://www.w3.org/2000/svg"
                width="60"
                height="55.714"
                viewBox="0 0 60 55.714"
              >
                <path
                  id="reception_icon"
                  data-name="reception icon"
                  d="M2.143,55.714a2.143,2.143,0,1,1,0-4.286H27.857V47.143H4.286A4.291,4.291,0,0,1,0,42.857V38.571A29.858,29.858,0,0,1,5.124,21.8a30.075,30.075,0,0,1,13.2-10.869,29.717,29.717,0,0,1,9.534-2.283V4.286H23.571a2.143,2.143,0,0,1,0-4.286H36.429a2.143,2.143,0,0,1,0,4.286H32.143V8.646a29.852,29.852,0,0,1,14.63,5.048,30.082,30.082,0,0,1,10.869,13.2A29.809,29.809,0,0,1,60,38.571v4.286a4.29,4.29,0,0,1-4.285,4.286H32.143v4.286H57.857a2.143,2.143,0,1,1,0,4.286ZM19.991,14.878a25.692,25.692,0,0,0-15.7,23.693v3.3a.99.99,0,0,0,.989.989h49.45a.99.99,0,0,0,.989-.989v-3.3A25.729,25.729,0,0,0,19.991,14.878Z"
                />
              </svg>
            </div>
            <p class="menuCardText24 text-left ml-3 mt-3 marginCard">
              {{ $t("Qa'bul") }}
            </p>
            <p class="menuCardText17  text-left ml-3 mt-4">
              {{ $t("Qabul_info") }}
            </p>
          </div>
        </div>
        <div class="col-sm-12 mt-3  col-md-6 col-lg-4 text-center">
          <div
            style="min-height:280px;"
            class="menuCard p-2 hover1 aboutButtons"
            @click="$router.push({ name: 'ota_onalar_tulovi' })"
          >
            <div class="text-left ml-3 mt-3">
              <svg
                class="svg"
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="44"
                viewBox="0 0 64 44"
              >
                <path
                  id="card_icon"
                  data-name="card icon"
                  d="M8,44a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0H56a8,8,0,0,1,8,8V36a8,8,0,0,1-8,8ZM4,8V36a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H8A4,4,0,0,0,4,8ZM44,28a4,4,0,0,1-4-4V20a4,4,0,0,1,4-4h8a4,4,0,0,1,4,4v4a4,4,0,0,1-4,4Zm0-7.5v3a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5h-7A.5.5,0,0,0,44,20.5Z"
                />
              </svg>
            </div>
            <p class="menuCardText24 text-left ml-3 mt-4">
              {{ $t("Ота_оналар_тўлови") }}
            </p>
            <p class="menuCardText17 text-left ml-3 mt-4">
              {{ $t("ota_ona_tolov_info") }}
            </p>
          </div>
        </div>
        <div class="col-sm-12 mt-3  col-md-6 col-lg-4 text-center">
          <div
            style="min-height:280px;"
            class="menuCard p-2 hover1 aboutButtons"
            @click="$router.push({ name: 'Oqishni-kochirish-va-tiklash' })"
          >
            <div class="text-left ml-3 mt-3">
              <svg
                class="svg"
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="47.723"
                viewBox="0 0 64 47.723"
              >
                <path
                  id="exchange_icon"
                  data-name="exchange icon"
                  d="M20.034,47.723h0A11.92,11.92,0,0,1,8.1,35.793l2.033-2.1,1.979,2.1a7.894,7.894,0,0,0,7.919,7.953H37.966a1.988,1.988,0,1,1,0,3.977ZM52.5,46.317l-8.139-8.139a1.988,1.988,0,1,1,2.812-2.812l4.715,4.715V11.931A8.015,8.015,0,0,0,43.9,3.977V0A11.945,11.945,0,0,1,54.888,7.287a11.885,11.885,0,0,1,.974,4.644V40.14l4.745-4.745a1.988,1.988,0,1,1,2.812,2.812l-8.11,8.11a1.988,1.988,0,0,1-2.812,0ZM12.115,35.792H8.1l.036-28.21L3.394,12.328a1.988,1.988,0,0,1-2.812,0,1.988,1.988,0,0,1,0-2.812l8.11-8.11a1.988,1.988,0,0,1,2.812,0l8.139,8.139a1.988,1.988,0,1,1-2.812,2.812L12.116,7.642v28.15ZM26.035,3.977a1.988,1.988,0,1,1,0-3.977H43.9L46,1.93,43.9,3.977H26.035Z"
                />
              </svg>
            </div>
            <p class="menuCardText22 text-left ml-3 mt-3 mb-0 pb-0">
              {{ $t("O'qishni ko'chirish va tiklash") }}
            </p>
            <p class="menuCardText17 text-left ml-3 mt-4 pt-2">
              {{ $t("oqish_kochirish_va_tiklash_info") }}
            </p>
          </div>
        </div>

        <div class="col-sm-12 mt-3 col-md-6 col-lg-4 text-center">
          <div
            style="min-height:280px;"
            class="menuCard p-2 hover1 aboutButtons"
            @click="$router.push({ name: 'Ijtimoiy-Soha' })"
          >
            <div class="text-left ml-3 mt-3">
              <svg
                class="svg"
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="59.151"
                viewBox="0 0 64 59.151"
              >
                <path
                  id="social_icon"
                  data-name="social icon"
                  d="M47.14,58.084a13.5,13.5,0,0,1-3.369-2.047q-.353.163-.712.315a23.345,23.345,0,0,1-18.117,0q-.36-.152-.712-.315A13.577,13.577,0,1,1,10.291,33.067q.261-.11.524-.209a23.194,23.194,0,0,1,6.728-14.4,23.4,23.4,0,0,1,3.072-2.588,13.674,13.674,0,0,1-.192-2.29,13.576,13.576,0,1,1,27.151,0,13.686,13.686,0,0,1-.191,2.289,23.417,23.417,0,0,1,8.06,9.985,23.049,23.049,0,0,1,1.74,7.008q.264.1.524.209A13.579,13.579,0,0,1,47.14,58.084Zm1.51-3.574a9.7,9.7,0,0,0,8.52-17.394,23.2,23.2,0,0,1-6.714,14.249,23.393,23.393,0,0,1-3,2.539A9.7,9.7,0,0,0,48.65,54.51ZM8.719,38.719A9.7,9.7,0,0,0,20.546,53.9a23.413,23.413,0,0,1-7.991-9.936,23.045,23.045,0,0,1-1.726-6.851A9.682,9.682,0,0,0,8.719,38.719ZM34,54.3a19.277,19.277,0,0,0,7.045-1.319A13.572,13.572,0,0,1,52.424,32q.38,0,.757.021A19.342,19.342,0,0,0,47.713,21.2,19.6,19.6,0,0,0,46.1,19.747a13.585,13.585,0,0,1-24.192,0A19.61,19.61,0,0,0,20.286,21.2,19.344,19.344,0,0,0,14.818,32.02Q15.2,32,15.575,32A13.574,13.574,0,0,1,26.955,52.984,19.277,19.277,0,0,0,34,54.3ZM48.65,36.641A9.7,9.7,0,0,0,44.525,51.2a19.506,19.506,0,0,0,7.344-8.745,19.223,19.223,0,0,0,1.5-6.534q-.468-.045-.944-.045A9.634,9.634,0,0,0,48.65,36.641ZM16.13,42.458A19.5,19.5,0,0,0,23.474,51.2a9.695,9.695,0,0,0-7.9-15.325q-.476,0-.944.045A19.223,19.223,0,0,0,16.13,42.458ZM27.143,20.432a9.7,9.7,0,0,0,15.669-2.8q-.619-.316-1.264-.588a19.462,19.462,0,0,0-15.1,0q-.644.272-1.263.588A9.656,9.656,0,0,0,27.143,20.432ZM30.225,4.641A9.69,9.69,0,0,0,24.3,13.576q0,.085,0,.17.316-.145.637-.281a23.35,23.35,0,0,1,18.117,0q.321.136.636.28,0-.085,0-.17A9.7,9.7,0,0,0,30.225,4.641Z"
                  transform="translate(-2)"
                />
              </svg>
            </div>
            <p class="menuCardText24 text-left ml-3 mt-3">
              {{ $t("Ijtimoiy_Soha") }}
            </p>
            <p class="menuCardText17 text-left ml-3 mt-3">
              {{ $t("Ijtimoiy_soha_info") }}
            </p>
          </div>
        </div>
        <div class="col-sm-12 mt-3 col-md-6 col-lg-4 text-center">
          <div
            style="min-height:280px;"
            class="menuCard p-2 hover1 aboutButtons"
            @click="$router.push({ name: 'Rasmiy-hujjatlar' })"
          >
            <div class="text-left ml-3 mt-3">
              <svg
                class="svg"
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="64"
                viewBox="0 0 48 64"
              >
                <path
                  id="document_icon"
                  data-name="document icon"
                  d="M8,64a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0H40a8,8,0,0,1,8,8V56a8,8,0,0,1-8,8ZM4,8V56a4,4,0,0,0,4,4H40a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H8A4,4,0,0,0,4,8Zm6,38a2,2,0,0,1,0-4H22a2,2,0,0,1,0,4Zm0-10a2,2,0,0,1,0-4H38a2,2,0,1,1,0,4Zm0-10a2,2,0,0,1,0-4H38a2,2,0,1,1,0,4Zm0-10a2,2,0,0,1,0-4H38a2,2,0,1,1,0,4Z"
                />
              </svg>
            </div>
            <p class="menuCardText24 text-left ml-3 mt-3">
              {{ $t("Rasmiy_hujjatlar") }}
            </p>
            <p class="menuCardText17 text-left ml-3 mt-3">
              {{ $t("Rasmiy_hujjat_info") }}
            </p>
          </div>
        </div>
        <div class="col-sm-12 mt-3 col-md-6 col-lg-4 text-center">
          <!-- <a
            href="http://salarycalc.webase.uz/#/"
            target="_blank"
            style="text-decoration: none;"
          >
            <div
              style="min-height:280px"
              class="menuCard p-2 hover1 aboutButtons"
            >
              <div class="text-left ml-3 mt-3">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="60.485"
                  viewBox="0 0 64 60.485"
                >
                  <path
                    id="calculator_icon"
                    data-name="calculator icon"
                    d="M21.071,59.9,14,52.829,6.929,59.9A2,2,0,1,1,4.1,57.071L11.172,50,4.1,42.929A2,2,0,0,1,6.929,40.1L14,47.172,21.071,40.1A2,2,0,0,1,23.9,42.929L16.829,50,23.9,57.071A2,2,0,1,1,21.071,59.9ZM38,58a2,2,0,0,1,0-4H62a2,2,0,0,1,0,4Zm0-12a2,2,0,0,1,0-4H62a2,2,0,0,1,0,4ZM12,26V16H2a2,2,0,0,1,0-4H12V2a2,2,0,0,1,4,0V12H26a2,2,0,0,1,0,4H16V26a2,2,0,0,1-4,0ZM38,16a2,2,0,0,1,0-4H62a2,2,0,0,1,0,4Z"
                  />
                </svg>
              </div>
              <p class="menuCardText24 text-left ml-3 mt-3">
                {{ $t("Calculator") }}
              </p>
              <p class="menuCardText17 text-left ml-3 mt-3">
                {{ $t("calculator_info") }}
              </p>
            </div>
          </a> -->
        </div>
      </div>
    </div>

    <div class="pb-5">
      <div class="container">
        <div class="row">
          <div class="col text-center mt-5">
            <p class="infoTextB">
              {{ $t("СТАТИСТИКА_ОРГАНИЗАЦИЙ") }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-4 col-lg-4 text-center mt-3">
            <img src="@/assets/pictures/teacher icon.png" alt="" />
            <p class="infoText mb-0">
              {{
                $options.filters.currency(infolist.employeesCount, {
                  symbol: "",
                  thousandsSeparator: " ",
                  fractionCount: "",
                })
              }}
              <!-- {{
                $options.filters.currency(603535, {
                  symbol: "",
                  thousandsSeparator: " ",
                  fractionCount: "",
                })
              }} -->
            </p>
            <p class="infoTextBlack">{{ $t("преподавателей") }}</p>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 text-center mt-3">
            <img src="@/assets/pictures/student icon.png" alt="" />
            <p class="infoText mb-0">
              {{
                $options.filters.currency(infolist.studentsCount, {
                  symbol: "",
                  thousandsSeparator: " ",
                  fractionCount: "",
                })
              }}
              <!-- {{
                $options.filters.currency(5922797, {
                  symbol: "",
                  thousandsSeparator: " ",
                  fractionCount: "",
                })
              }} -->
            </p>
            <p class="infoTextBlack">{{ $t("учащихся") }}</p>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4 text-center mt-3">
            <img src="@/assets/pictures/school icon.png" alt="" />
            <p class="infoText mb-0">
              {{
                $options.filters.currency(infolist.organizationCount, {
                  symbol: "",
                  thousandsSeparator: " ",
                  fractionCount: "",
                })
              }}
              <!-- {{
                $options.filters.currency(10527, {
                  symbol: "",
                  thousandsSeparator: " ",
                  fractionCount: "",
                })
              }} -->
            </p>
            <p class="infoTextBlack">{{ $t("Школ") }}</p>
          </div>
        </div>
        <!-- <b-row>
          <b-col class="text-center">
            <div @click="$router.push({ name: 'infoPupil' })">
              <img
                class="mb-0 pb-0 right"
                style="cursor:pointer;"
                src="@/assets/scroll-down.gif"
                alt="this slowpoke moves"
                width="100"
              />
            </div>
          </b-col>
        </b-row> -->
      </div>
    </div>
  </div>
</template>

<script>
import ServiceService from "@/services/Service.service";
import HelperService from "@/services/Helper.service";
import RegulationsService from "@/services/Regulations.service";
export default {
  data() {
    return {
      RegulationsInfo: [],
      items: [],
      info: [],
      SearchInfo: [],
      isBusy: false,
      infolist: [],
      itemsSearch: [],
      searchshow: false,
      TabIndex: 0,
      filter: {
        Search: "",
        Lang: "",
        SortColumn: "",
        OrderType: "desc",
        OffSet: "",
        PageNumber: 1,
        PageLimit: 1000,
        pageOptions: [5, 10, 15, 20, 25, 50, 1000],
        SortIcon: "cil-arrow-top",
        IsStartPageFromZero: false,
        parentID: "",
      },
    };
  },
  created() {
    this.filter.Lang = localStorage.getItem("lang") || "uz_cyrl";
    RegulationsService.GetChildList(
      this.filter.Search,
      this.filter.Lang,
      this.filter.SortColumn,
      this.filter.OrderType,
      this.filter.OffSet,
      this.filter.PageNumber,
      this.filter.PageLimit,
      this.filter.IsStartPageFromZero,
      this.filter.parentID
    ).then((res) => {
      this.RegulationsInfo = res.data.rows;
      this.Loading = false;
      this.info = this.RegulationsInfo.sort();
    });
    // RegulationsService.Get(this.$route.params.id).then((res) => {
    //   this.RegulationsInfo = res.data;
    // });
    this.Refresh();
    // this.Search2()
  },
  methods: {
    // ChooseParentID() {
    //   this.TabIndex = el.id;
    //   this.parent = this.RegulationsInfo.filter(
    //     (item) => item.parentid === this.TabIndex
    //   )
    //   this.$router.push({
    //     name: "Regulations",
    //     params: { id: RegulationsInfo.id },
    //   });
    // },
    closeschoolinfo() {
      this.searchshow = false;
    },
    search() {
      this.searchshow = true;
      this.isBusy = true;
      ServiceService.GetList(
        this.filter.Search,
        this.filter.SortColumn,
        this.filter.OrderType,
        this.filter.PageNumber,
        this.filter.PageLimit
      ).then((res) => {
        this.isBusy = false;
        this.items = res.data.rows;
        // this.totalRows = res.data.total;
      });
    },
    Search2() {
      this.searchshow = true;
      this.isBusy = true;
      RegulationsService.GetList(
        this.filter.Search,
        this.filter.Lang,
        this.filter.SortColumn,
        this.filter.OrderType,
        this.filter.OffSet,
        this.filter.PageNumber,
        this.filter.PageLimit,
        this.filter.IsStartPageFromZero
      ).then((res) => {
        this.isBusy = false;
        this.itemsSearch = res.data.rows;
        // this.SearchInfo - this.itemsSearch.sort()
        // this.totalRows = res.data.total;
      });
    },
    RouterPush(item) {
      this.$router.push({
        name: "Regulations",
        params: {
          id: item.id,
        },
      });
    },
    Refresh() {
      HelperService.GetOrgAndPersonCount().then((res) => {
        this.infolist = res.data;
        // this.items = this.GetAllSchools;
        // this.items = res.data.rows;
        // this.totalRows = res.data.total;
      });
    },
  },
};
</script>

<style>
.card-body {
  padding: 12px;
}
.classA {
  padding-right: 15px;
  color: #1d70b8;
  text-decoration: #1d70b8 underline;
  font-weight: bold;
  font-size: 18px;

  transition: all 500ms ease;
  cursor: pointer;
}
.classA:hover {
  color: #082852;
  text-decoration: #082852 underline;
  /* font-size: 17px; */
  font-weight: bolder;
  transition: all 500ms ease;
}
.colorClass {
  background: #121fcf;
  background: -webkit-linear-gradient(
    to bottom,
    #000 0%,
    rgba(0, 0, 0, 0.33) 100%
  );
  background: -moz-linear-gradient(
    to bottom,
    #000 0%,
    rgba(0, 0, 0, 0.357) 100%
  );
  background: linear-gradient(to bottom, #000 0%, rgba(0, 0, 0, 0.357) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-box;
}
.right {
  transform: rotate(-90deg);
}
.redCard {
  border-radius: 15px;
  position: absolute;
  margin-left: 2%;
  top: -10% !important;
}
.redCard :hover {
  background: transparent;
  border-radius: none !important;
}
.iconStyle {
  fill: #fff;
  opacity: 1;
}
.iconStyle :hover {
  fill: #fff !important;
  opacity: 1;
}
</style>
